document.addEventListener('click', function (e) {
    
  const link = e.target.closest('.p7-share-link');
  if (!link) return;

  e.preventDefault();

  const url = link.getAttribute('href');
  const w = 550;
  const h = 450;

  const left = (screen.width / 2) - (w / 2);
  const top = (screen.height / 2) - (h / 2);

  window.open(
    url,
    'p7ShareWindow',
    `width=${w},height=${h},top=${top},left=${left},noopener,noreferrer`
  );
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.share-instagram');
  if (!btn) return;

  const url = btn.dataset.copy;

  navigator.clipboard.writeText(url).then(() => {
    btn.classList.add('copied');
    setTimeout(() => btn.classList.remove('copied'), 1500);
  });
});
